import getFormatMessage from '../../locales/get-format-message';

const ErrKeyMessageMap: Record<number, Record<string, string>> = {
  101883: { serviceOpen: '当前服务已有业务开通使用, 不支持删除' },
};

export const getApiErrorMsg = (res: any) => {
  if (res.code === 0) {
    return;
  }
  const errKeyMsg = ErrKeyMessageMap[res.code]?.[res.data.key];
  if (!errKeyMsg) {
    return getFormatMessage(String(res.code));
  }

  return errKeyMsg;
};
